import { Injectable } from '@angular/core';

import { LatLng } from 'leaflet';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { BoundingBox, MapLayer } from 'src/app/bgsLeaflet/public_api';
import { PlacedPinMapLayer } from './mapLayers/placedPinMapLayer';
import { VolcanoMapLayer } from './mapLayers/volcanoMapLayer';
@Injectable({
  providedIn: 'root',
})
export class EVMapService {
  private readonly mapLayersSrc = new BehaviorSubject<Array<MapLayer>>(MAP_LAYERS.slice());
  private readonly baseLayersSrc = new BehaviorSubject<Array<MapLayer>>([]);
  private readonly placingPinOnMapSrc = new BehaviorSubject<boolean>(false);
  private readonly placedPinPositionSrc = new BehaviorSubject<L.LatLng>(null);
  private setPlacedPinTimeout: NodeJS.Timeout;
  private readonly startBBoxSource = new Subject<void>();
  private readonly clearBBoxSource = new Subject<void>();
  private readonly zoomLocationSource = new BehaviorSubject<L.LatLng>(null);
  private readonly bBoxSource = new BehaviorSubject<BoundingBox>(BoundingBox.makeUnbounded());

  constructor() {
    this.watchPlacedPinPosition().subscribe((latLng: L.LatLng) => {
      // console.debug('watchPlacedPinPosition', latLng);
      this.addMapLayer(new PlacedPinMapLayer(latLng));
    });
    // init empty
    this.addMapLayer(new PlacedPinMapLayer());
  }

  get mapLayers(): Array<MapLayer> {
    return this.mapLayersSrc.value.slice();
  }
  public watchMapLayers(): Observable<Array<MapLayer>> {
    return this.mapLayersSrc.asObservable();
  }
  public addMapLayer(mapLayer: MapLayer): void {
    const mapLayersArray = this.mapLayers.filter((layer) => layer.id !== mapLayer.id);
    mapLayersArray.push(mapLayer);
    this.mapLayersSrc.next(mapLayersArray);
  }

  get baseLayers(): Array<MapLayer> {
    return this.baseLayersSrc.value.slice();
  }
  public setBaseLayers(baseLayers: Array<MapLayer>): void {
    this.baseLayersSrc.next(baseLayers);
  }
  public watchBaseLayers(): Observable<Array<MapLayer>> {
    return this.baseLayersSrc.asObservable();
  }

  get placingPin(): boolean {
    return this.placingPinOnMapSrc.value;
  }
  public setPlacingPin(placingPin: boolean): void {
    this.placingPinOnMapSrc.next(placingPin);
    this.placedPinPositionSrc.next(null);
  }
  public watchPlacingPin(): Observable<boolean> {
    return this.placingPinOnMapSrc.asObservable();
  }

  get placedPinPosition(): L.LatLng {
    return this.placedPinPositionSrc.value;
  }
  public setPlacedPinPosition(latLng: L.LatLng): void {
    // don't call it too often
    clearTimeout(this.setPlacedPinTimeout);
    this.setPlacedPinTimeout = setTimeout(() => {
      // only if changed
      if (JSON.stringify(latLng) !== JSON.stringify(this.placedPinPositionSrc.value)) {
        this.placingPinOnMapSrc.next(false);
        let roundedLatLng: LatLng = null;
        if (null != latLng) {
          roundedLatLng = new LatLng(
            Number(Number.parseFloat(String(latLng.lat)).toFixed(4)),
            Number(Number.parseFloat(String(latLng.lng)).toFixed(4)),
          );
        }
        this.placedPinPositionSrc.next(roundedLatLng);
      }
    }, 100);
  }
  public watchPlacedPinPosition(): Observable<L.LatLng> {
    return this.placedPinPositionSrc.asObservable();
  }

   
  public watchStartDrawBoundingBox(): Observable<any> {
    return this.startBBoxSource.asObservable();
  }
  public startDrawBoundingBox(): void {
    this.startBBoxSource.next();
  }

   
  public watchClearBoundingBox(): Observable<any> {
    return this.clearBBoxSource.asObservable();
  }
  public clearBoundingBox(): void {
    this.clearBBoxSource.next();
  }

   
  public watchBoundingBox(): Observable<any> {
    return this.bBoxSource.asObservable();
  }
  public setBoundingBox(bbox: BoundingBox): void {
    this.bBoxSource.next(bbox);
  }
  public getBoundingBox(): BoundingBox {
    return this.bBoxSource.getValue();
  }

  public watchZoomToLocation(): Observable<L.LatLng> {
    return this.zoomLocationSource.asObservable();
  }
  public zoomToLocation(latLng: L.LatLng): void {
    this.zoomLocationSource.next(latLng);
  }
}

const MAP_LAYERS = [new VolcanoMapLayer()];
